<template>
    <div class="container">
        <div class="mb-6">
            <form class="filters-form" ref="form" method="POST" :action="action">
                <div class="columns">
                    <div class="column is-10 is-relative">
                        <tags-input element-id="tags"
                                    input-id="tag"
                                    v-bind:class="{'has-clear' : selectedTags.length > 0}"
                                    v-model="selectedTags"
                                    :existing-tags="results"
                                    id-field="id"
                                    text-field="name"
                                    :placeholder="lang('Cerca')"
                                    :typeahead="true"
                                    :typeahead-hide-discard="true"
                                    @change="getTags"
                        >
                        </tags-input>
                        <div class="clear-tags" @click="reset" v-if="selectedTags.length > 0">
                            <i class="fas fa-times" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="column is-2">
                        <div class="buttons">
                            <button @click.prevent="submit" class="button is-link is-fullwidth" v-bind:class="{ 'is-loading': loading}" :disabled="loading">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <input type="hidden" name="tags" v-if="selectedTags.length === 0" value="">
                <input type="hidden" name="_token" :value="token">
            </form>
        </div>
    </div>
</template>

<script>
import FormErrors from './../Classes/FormErrors'
import axios from 'axios';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import _ from "lodash";

export default {
    props: {
        token: {
            required: true,
            type: String
        },
        action: {
            required: true,
            type: String
        },
        old: {
            required: false,
            type: Array
        },
        value: {
            required: false,
            type: String,
        },
    },
    data(){
        return {
            selectedTags: [],
            tags: [],
            results: [],
            loading: false,
            clearing: false,
            errors: new FormErrors()
        }
    },
    components: {
        "tags-input" : VoerroTagsInput
    },
    mounted() {
        if( ! _.isEmpty( this.old )){
            this.selectedTags = this.old;
        }

        if( ! _.isEmpty( this.value )) {
            this.selectedTags.push({'id': '', 'name': this.value});
        }
    },
    methods: {
        getTags(value) {
            this.results = [];
            if(value.length > 2) {
                this.loading = true
                axios.get('/timeline/api/tags',{params: {query: value}}).then(response => {
                    this.loading = false;
                    this.results = response.data;
                }).catch( error => {
                    this.loading = false;
                    this.errors.record(error.response.data.errors);
                } );
            }
        },
        submit() {
            this.loading = true;
            this.$refs.form.submit();
        },
        reset() {
            this.loading = true;
            this.clearing = true;
            this.selectedTags = [];

            setTimeout(() => this.$refs.form.submit(), 0)
        }
    }
}
</script>
